/**
 * Shader module - imports all shader source files as raw strings.
 *
 * When processed by Vite, the ?raw suffix imports the file content as a string.
 * When processed by Rollup (legacy build), the build/shaders/shaders.js module
 * is used instead (generated by the Gulp shaders task).
 */

import pointcloud_vs from './pointcloud.vs?raw';
import pointcloud_fs from './pointcloud.fs?raw';
import pointcloud_sm_vs from './pointcloud_sm.vs?raw';
import pointcloud_sm_fs from './pointcloud_sm.fs?raw';
import pointcloud_dynamic_vs from './pointcloud_dynamic.vs?raw';
import pointcloud_dynamic_fs from './pointcloud_dynamic.fs?raw';
import normalize_vs from './normalize.vs?raw';
import normalize_fs from './normalize.fs?raw';
import normalize_and_edl_fs from './normalize_and_edl.fs?raw';
import edl_vs from './edl.vs?raw';
import edl_fs from './edl.fs?raw';
import blur_vs from './blur.vs?raw';
import blur_fs from './blur.fs?raw';

export const Shaders: Record<string, string> = {
  'pointcloud.vs': pointcloud_vs,
  'pointcloud.fs': pointcloud_fs,
  'pointcloud_sm.vs': pointcloud_sm_vs,
  'pointcloud_sm.fs': pointcloud_sm_fs,
  'pointcloud_dynamic.vs': pointcloud_dynamic_vs,
  'pointcloud_dynamic.fs': pointcloud_dynamic_fs,
  'normalize.vs': normalize_vs,
  'normalize.fs': normalize_fs,
  'normalize_and_edl.fs': normalize_and_edl_fs,
  'edl.vs': edl_vs,
  'edl.fs': edl_fs,
  'blur.vs': blur_vs,
  'blur.fs': blur_fs,
};
